import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  CircularProgress,
  IconButton,
  Paper,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { CreateBannerApi, uploadFile } from "../../DAL/create";
import { enqueueSnackbar } from "notistack";
import moment from "moment";

const AddBanner = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fileUploaded1, setFileUploaded1] = useState(false);
  const [fileURL1, setFileURL1] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [file, setFile] = useState();
  const [inputs, setInputs] = useState({
    imageId: "",
    country: "",
    startTime: null,
    endTime: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileUploaded1(false);
    setFilePreview(selectedFile ? URL.createObjectURL(selectedFile) : null);
  };

  const handleFileSubmit1 = async (e) => {
    e.preventDefault();
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    try {
      const imagedata = await uploadFile(formData);
      setFileURL1(imagedata.data.id);
      setFileUploaded1(true);
      enqueueSnackbar("File uploaded successfully!", { variant: "success" });
    } catch (error) {
      console.error("Error uploading file:", error);
      enqueueSnackbar("Failed to upload file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      imageId: fileURL1,
      country: inputs.country,
      startTime: moment(inputs.startTime).format("YYYY-MM-DD HH:mm:ss.SSSSZ"),
      endTime: moment(inputs.endTime).format("YYYY-MM-DD HH:mm:ss.SSSSZ"),
    };

    const resp = await CreateBannerApi(data);
    if (resp?.data?.statusCode === 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate(-1);
    } else {
      enqueueSnackbar(
        resp?.message ||
          resp?.error ||
          resp?.data?.error ||
          resp?.data?.message,
        { variant: "error" }
      );
    }
  };

  return (
    <Box
      sx={{
        minHeight: "95vh",
        display: "flex",
        justifyContent: "center",
        // alignItems: "center",
        backgroundColor: "#f5f6fa",
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 700,
          width: "100%",
          height: "80vh",
          p: 4,
          borderRadius: 3,
          background: "#fff",
        }}
      >
        {/* Header */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" sx={{ ml: 1, fontWeight: 600 }}>
            Add Banner
          </Typography>
        </Box>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label="Country *"
                fullWidth
                value={inputs.country}
                name="country"
                size="small"
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="Start Date & Time *"
                  value={inputs.startTime}
                  onChange={(newValue) =>
                    setInputs((prev) => ({ ...prev, startTime: newValue }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small" />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="End Date & Time *"
                  value={inputs.endTime}
                  onChange={(newValue) =>
                    setInputs((prev) => ({ ...prev, endTime: newValue }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small" />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Upload Image *
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                />
                <Button
                  variant="contained"
                  color={fileUploaded1 ? "success" : "primary"}
                  onClick={handleFileSubmit1}
                  disabled={loading || !file}
                  sx={{ textTransform: "none" }}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : fileUploaded1 ? (
                    "Uploaded"
                  ) : (
                    "Upload"
                  )}
                </Button>
              </Box>
              {filePreview && (
                <Box sx={{ mt: 2 }}>
                  <img
                    src={filePreview}
                    alt="preview"
                    style={{
                      maxHeight: 150,
                      borderRadius: 8,
                      border: "1px solid #ddd",
                    }}
                  />
                </Box>
              )}
            </Grid>

            <Grid item xs={12} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                type="submit"
                className="gradientButton"
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default AddBanner;
